<template>
  <div>
    <v-divider class="mb-8" />

    <h4 class="mw-350 mt-5 mb-5">
      {{ $t('appointment.additionalData.modalTitle') }}
    </h4>

    <!-- form -->
    <div class="d-flex">
      <v-select v-model="type" :items="types" :label="$t('appointment.additionalData.type')" class="mw-150 mr-4" hide-details="auto" outlined />
      <v-text-field v-model="title" :label="$t('appointment.additionalData.title')" hide-details="auto"  outlined />
    </div>

    <div v-if="type" class="d-flex mt-4">
      <!-- type field -->
      <div class="fields-value">
        <HPhone v-show="type === 'PHONE'" v-model="value" :country="country" ref="phone" />
        <v-text-field v-show="type === 'LINK' || type === 'OTHER' || type === 'EMAIL'" v-model="value" :label="$t(`appointment.additionalData.types.${type}`)" outlined />
      </div>
      <!-- /type field -->

      <v-btn @click="addDetail" color="primary" class="add-field-button" outlined large>
        <v-icon left>
          mdi-plus
        </v-icon>
        <span>{{ $t('appointment.additionalData.add') }}</span>
      </v-btn>
    </div>
    <!-- /form -->

    <!-- list -->
    <span v-if="additionalDataListRequest.length >= 1">
      <v-divider :class="`${type ? 'mt-0' : 'mt-6'} mb-5`" />

      <h5 class="grey--text pt-0">
        {{ $t('appointment.additionalData.fields') }}
      </h5>

      <div class="px-4">
        <v-row no-gutters>
          <v-col cols="4">
            <h6 class="text-uppercase grey--text pt-0 pb-2">
              {{ $t('appointment.additionalData.title') }}
            </h6>
          </v-col>
          <v-col>
            <h6 class="text-uppercase grey--text pt-0 pb-2">
              {{ $t('appointment.additionalData.value') }}
            </h6>
          </v-col>
        </v-row>
      </div>

      <v-card outlined>
        <span v-for="(item, index) in additionalDataListRequest" :key="index">
          <v-row class="pl-4 py-1" no-gutters>
            <v-col cols="4">
              <span class="d-block body-2 mt-2">{{ item.title }}</span>
            </v-col>
            <v-col cols="5">
              <span class="d-block body-2 mt-2">{{ item.value }}</span>
            </v-col>
            <v-col cols="3" align="center">
              <div class="d-flex justify-end">
                <v-btn @click="removeDetail(item, index)" class="mr-2" icon>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="pointer" color="error" v-bind="attrs" v-on="on" small>
                        mdi-delete
                      </v-icon>
                    </template>
                    <span>
                      {{ $t('appointment.additionalData.remove') }}
                    </span>
                  </v-tooltip>
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-divider />
        </span>
      </v-card>
    </span>
    <!-- /list -->

    <!-- no additional data -->
    <v-alert v-else class="grey lighten-4 mt-6">
      <span class="d-block text-center">
        {{ $t('appointment.additionalData.noAdditionalData') }}
      </span>
    </v-alert>
    <!-- /no additional data -->
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

import HPhone from '@/components/app/HPhone'

export default {
  name: 'AppointmentCustomFields',

  components: {
    HPhone,
  },

  computed: {
    isFieldsEmpty() {
      return !this.title || !this.value || !this.type
    },

    country: {
      get() {
        return localStorage.getItem('user_country')
      },
      set(value) {
        return value
      }
    },

    types() {
      return [
        {
          text: this.$t('appointment.additionalData.types.PHONE'),
          value: 'PHONE',
        },
        {
          text: this.$t('appointment.additionalData.types.LINK'),
          value: 'LINK',
        },
        {
          text: this.$t('appointment.additionalData.types.EMAIL'),
          value: 'EMAIL',
        },
        {
          text: this.$t('appointment.additionalData.types.OTHER'),
          value: 'OTHER',
        }
      ]
    },
  },

  watch: {
    type(value) {
      this.value = null

      if (value === 'PHONE') {
        this.$refs.phone.currentCountryCode = '+55'
      }

      if (value === 'LINK') {
        this.value = 'https://'
      }
    },
  },

  methods: {
    ...mapMutations(['setAppointmentFields']),

    resetFields() {
      this.type = null
      this.title = null
      this.value = null
    },

    handleAppointmentCustomFields(value) {
      this.setAppointmentFields({
        update_additional_data: {
          additional_data_list_request: value,
        }
      })
    },


    removeDetail(item, index) {
      this.additionalDataListRequest.splice(index, 1)
      this.resetFields()
    },

    addDetail() {
      if (this.isFieldsEmpty) {
        this.$store.dispatch('showErrorMessage', 'Please fill all fields')
        return
      }

      this.additionalDataListRequest.push({
        title: this.title,
        value: this.value,
        type: this.type,
      })

      this.handleAppointmentCustomFields(this.additionalDataListRequest)
      this.resetFields()
    },
  },

  data() {
    return {
      additionalDataListRequest: [],

      type: null,
      title: null,
      value: null,
      defaultValue: null,
      itemIndex: null,
    }
  }
}
</script>

<style>
.fields-value {
  width: 100%;
  margin-right: 15px;
}

.add-field-button {
  height: 54px !important;
}
</style>
